<template>
    <div class="" style="">
      <div class="topImgContent">
        <div class="topImgTitleContent">
          <div class="topImgTitle">活动报名记录</div>
          <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
        </div>
      </div>
      <div class="e-flex" style="justify-content: center;">
        <div class="ar_listContent">
            <div class="ar_list e-flex" v-for="(item, index) in list" @click="goDetail(item.activityId)">
                <img class="ar_listImg" :src="item.thumbUrl">
                <div class="ar_listRight">
                    <div class="ar_listTItle e-line-1">{{ item.title}}</div>
                    <div class="ar_listDate">报名时间：{{ item.createDate.slice(0,16) }}</div>
                    <div class="ar_listUser">报名人：{{ item.names}}</div>
                </div>
            </div>
        </div>
      </div>
      <div class="noDataContent" v-if="list.length == 0">
        <img class="noDataImg" src="@/assets/images/noDataImg.png">
        <div class="noDataText">暂无内容</div>
      </div>
      <div class="e-flex pd_paginationContent">
        <el-pagination background layout="prev, pager, next, jumper" :page-size="10" :total="total" @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </template>
  
  <script>
    import '../../styles/activityRegistration.css'
    export default {
      name: 'activityRegistration',
      data () {
        return {
            page: 1,
            list: [],
            user: JSON.parse(localStorage.getItem('user')),
            total: 0
        }
      },
      created() {
        this.getDetail()
      },
      methods: {
        pageChange() {
            this.page = e
            this.getDetail()
        },
        goDetail(activityId) {
            this.$router.push({ path: '/activityRegistration/activityRegistrationDetail', query: {activityId: activityId}})
        },
        getDetail() {
          this.request({
              url: 'activity/applyList',
              method: 'post',
              data: {
                userId: this.user.id ? this.user.id : this.user.data.id,
                page: this.page,
                limit: 10
              }
          }).then(res => {
              this.list = res.data
              this.total = recordsTotal
          })
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/activityRegistration/index.vue